import * as tslib_1 from "tslib";
import { Component, Inject } from "vue-property-decorator";
import { H3Textarea } from "h3-mobile-vue";
import { AddressControl } from "../control/address-control";
import { FromAddressValueService } from "@cloudpivot/form/src/common/services";
import { FormLocationControl } from "@cloudpivot/form/src/common/controls/form-location-control";
// import {
//   BaseControl,
//   FormLocationControl,
//   AddressControl
// } from "../../controls";
// import  pca  from '../shared/pca-selector/typings/pca';
// import PcaSelector from "../shared/mobile-pca-selector/pca-selector.vue";
// import { FromAddressValueService } from "../../services";
import MutilText from "@cloudpivot/form/src/common/components/mutil-text.vue";
// import SmartLocation from "../shared/mobile-smart-location/smart-location.vue";
let Address = class Address extends AddressControl {
    // import SmartLocation from "../shared/mobile-smart-location/smart-location.vue";
    constructor() {
        super(...arguments);
        this.isShowPosition = true;
        this.showLocation = false;
        // setPcaDate() {
        //   let data:any = JSON.parse(JSON.stringify(this.ctrl.value));
        //   delete data.address;
        //   this.pca = data;
        // }
        // get addressString() {
        //   const { provinceName, cityName, districtName, address} = this.ctrl.value;
        //   const addressList:Array<any> = [];
        //   addressList.push(provinceName, cityName, districtName, address);
        //   const str = addressList.reduce((str:string,current:string)=> {
        //     let currentStr:string = '';
        //     let beforeStr:String = '';
        //     if(current) {
        //       currentStr = current;
        //     }
        //     if (str) {
        //       beforeStr = str;
        //     }
        //      return `${beforeStr} ${currentStr}`
        //   });
        //   return str
        // }
        // unsubscribe() {
        //   if (this.subscription) {
        //     this.subscription.unsubscribe();
        //     this.subscription = undefined;
        //   }
        // }
        // destroyed() {
        //   super.destroyed();
        //   this.unsubscribe();
        // }
    }
    //上下布局模式
    get layoutType() {
        if (this.layoutTypeFn) {
            return this.layoutTypeFn();
        }
    }
    // pca:any = {}
    // setControl() {
    //   if (this.ctrl.value) {
    //     this.setPcaDate();
    //   }
    //   // this.unsubscribe();
    //   // this.subscription = (this.ctrl as any).valueChange.subscribe((change:any) => {
    //   //   this.setPcaDate();
    //   // });
    // }
    // handleValueChange(){
    //   this.setPcaDate();
    // }
    valueChange(val) {
        super.valueChange(val);
    }
    mounted() {
        if (this.autoGetLocation) {
            if (this.initMap) {
                this.initMap().then((vmap) => {
                    vmap.lazyAMapApiLoaderInstance.load().then(() => {
                        this.initLocation();
                    });
                });
            }
        }
    }
    initLocation() {
        const geolocation = new AMap.Geolocation({
            // 是否使用高精度定位，默认：true
            enableHighAccuracy: true,
            // 设置定位超时时间，默认：无穷大
            timeout: 10000,
            // 定位按钮的停靠位置的偏移量，默认：Pixel(10, 20)
            buttonOffset: new AMap.Pixel(10, 20),
            //  定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
            zoomToAccuracy: true,
            //  定位按钮的排放位置,  RB表示右下
            buttonPosition: "RB"
        });
        const vm = this;
        geolocation.getCurrentPosition((status, result) => {
            if (status === "complete" && result.info === "SUCCESS") {
                const adComponent = result.addressComponent;
                const add = `${adComponent.township}${adComponent.street}${adComponent.streetNumber}`;
                const { province, city, district } = adComponent;
                const backData = {
                    lng: result.position.lng,
                    lat: result.position.lat,
                    provinceName: province,
                    cityName: city,
                    districtName: district,
                    adcode: result.addressComponent.adcode,
                    address: add
                };
                this.mapChange(backData);
            }
        });
    }
    get initMap() {
        return FormLocationControl.service.initMap;
    }
    get autoGetLocation() {
        if (!this.getIsNew()) {
            return false;
        }
        if (!this.controlOpts.autoGetLocation) {
            return false;
        }
        else {
            return this.controlOpts.autoGetLocation === 'true';
        }
    }
    textAreaChange(val) {
        if (this.ctrl.value) {
            this.ctrl.value.address = val;
        }
    }
    // created() {
    //     debugger
    //     this
    // }
    // get showEmpty() {
    //   return this.controlOpts.showEmpty === 'true';
    // }
    getPosition() {
        if (this.readonly || this.readonlyFormula)
            return;
        this.showLocation = true;
        const smartlocation = this.$refs.smartlocation;
        if (smartlocation) {
            smartlocation.getFocus();
        }
        // FormLocationControl.service.position(200, true).then(result => {
        //   const val:any =  FromAddressValueService.setAddressVal(result.adcode,this.controlOpts.locationType);
        //   this.ctrl.value = Object.assign(result,val);
        //   this.setPcaDate();
        // })
    }
    mapChange(val) {
        if (val.adcode) {
            FromAddressValueService.setAddressVal(val.adcode, this.controlOpts.locationType).then((location) => {
                const type = this.controlOpts.locationType.split("-").length;
                if (type === 3) {
                    location.address = val.address;
                }
                else if (type === 2) {
                    location.address = `${val.districtName}${val.address}`;
                }
                else {
                    location.address = `${val.cityName}${val.districtName}${val.address}`;
                }
                this.ctrl.value = Object.assign(val, location);
                this.setPcaDate();
            });
        }
        else {
            this.ctrl.value = null;
        }
    }
    close() {
        this.showLocation = false;
    }
};
tslib_1.__decorate([
    Inject()
], Address.prototype, "layoutTypeFn", void 0);
Address = tslib_1.__decorate([
    Component({
        name: "input-text",
        components: {
            PcaSelector: () => import("@cloudpivot/form/src/common/components/mobile-pca-selector/pca-selector.vue"),
            H3Textarea,
            MutilText,
            SmartLocation: () => import("@cloudpivot/form/src/common/components/mobile-smart-location/smart-location.vue")
        }
    })
], Address);
export default Address;
